import { TextField } from "material-ui";

import React, { Component } from "react";
import { notify } from "react-notify-toast";
import Select from "react-select";
import db from "../firebase";

export default class Discount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productName: "",
      productDescription: "",
      productPrice: 0,
      singleTag: "",
      additionalItems: [{ name: "", quantity: 0, price: 0 }],
      user: JSON.parse(localStorage.getItem("Ubytes")),
    };
    this.submit = this.submit.bind(this);
  }
  async componentDidMount() {
    let user = this.state.user;
    if (user.role === "Merchant") {
      await this.loadBranch(this.state.user.uid);
    } else if (user.role === "Superadmin") {
      await this.loadMerchant();
    }
  }

  async loadMenu(id) {
    var k = [];
    if (id && this.state.user.role === "Branch") {
      var data = await db.collection("Products").where("of", "==", id).get();
      data.forEach((el) => {
        var _ = el.data();
        _["value"] = el.data().productName;
        _["label"] = el.data().productName;
        k.push(_);
      });
    } else if (
      (id && this.state.user.role === "Merchant") ||
      this.state.user.role === "Superadmin"
    ) {
      var data = await db.collection("Products").where("of", "==", id).get();
      data.forEach((el) => {
        var _ = el.data();
        _["value"] = el.data().productName;
        _["label"] = el.data().productName;
        k.push(_);
      });
    }
    this.setState({ menu: k });
  }
  async loadMerchant() {
    var k = [];
    var data = await db.collection("Merchant").get();
    data.forEach((el) => {
      var _ = el.data();
      _["value"] = el.data().brandName;
      _["label"] = el.data().brandName;
      k.push(_);
    });
    this.setState({ merchant: k });
  }
  async loadBranch(id = null) {
    var k = [];
    if (id && this.state.user.role === "Branch") {
      let branch = await db.collection("Branches").doc(id).get();
      let _ = branch.data();
      _["value"] = branch.data().branchName;
      _["label"] = branch.data().branchName;
      this.setState({ selectedBranch: _ });
      return;
    }
    if (
      (id && this.state.user.role === "Merchant") ||
      this.state.user.role === "Superadmin"
    ) {
      var data = await db.collection("Branches").where("of", "==", id).get();

      data.forEach((el) => {
        var _ = el.data();

        _["value"] = el.data().branchName;
        _["label"] = el.data().branchName;
        k.push(_);
      });
    }

    this.setState({ branch: k });
  }
  async submit() {
    let user = this.state.user;
    if (!this.state.discountOn) {
      notify.show("Please Select Discount on", "error");
      return;
    }
    if (!this.state.discountItems) {
      notify.show("Please Select items", "error");
      return;
    }
    if (user.role === "Merchant" && !this.state.selectedBranch) {
      notify.show("Please Select a Branch", "error");
      return;
    }
    if (
      (user.role === "Superadmin" && !this.state.selectedMerchant) ||
      !this.state.selectedBranch
    ) {
      notify.show("Please Select a Branch and Merchant both", "error");
      return;
    }
    await db.collection("discount").add({
      discountOn: this.state.discountOn,

      of:
        this.state.user.role === "Merchant" ||
        this.state.user.role == "Superadmin"
          ? this.state.selectedBranch.branchId
          : this.state.role === "Branch"
          ? this.state.user.branchId
          : null,
      discountItems: this.state.discountItems,
      discount: this.state.productPrice,
    });
    notify.show("Discount Added Successfully", "success");
  }

  render() {
    return (
      <div className="add_menu_item">
        <h3>Add Discount</h3>
        <div className="add_menu_item_form">
          <div className="add_form_control-select">
            <label htmlFor="pName">Discount On</label>
            <Select
              options={[
                { value: "menu", label: "Menu" },
                { value: "combo", label: "Combo" },
                { value: "category", label: "Category" },
              ]}
              onChange={(e) => this.setState({ discountOn: e })}
              isMulti
              className="basic-multi-select"
              classNamePrefix="select"
            ></Select>
          </div>
          {this.state.user.role == "Merchant" ? (
            <div className="add_form_control-select">
              <label htmlFor="pDesc">Branch</label>
              <Select
                options={this.state.branch}
                onChange={(e) => {
                  this.setState({ selectedBranch: e });
                  this.loadMenu(e.branchId);
                }}
                className="basic-multi-select"
                classNamePrefix="select"
              ></Select>
            </div>
          ) : this.state.user.role === "Superadmin" ? (
            <>
              <Select
                onChange={(e) => {
                  this.setState({ selectedMerchant: e });
                  this.loadBranch(e.uid);
                }}
                options={this.state.merchants}
              ></Select>
              <Select
                options={this.state.branch}
                onChange={(e) => {
                  this.setState({ selectedBranch: e });
                  this.loadMenu(e.branchId);
                }}
              ></Select>
            </>
          ) : this.state.user.role === "Branch" ? null : null}

          <div className="add_form_control-select">
            <label htmlFor="pDesc">Discount Item</label>
            <Select
              options={this.state.menu}
              onChange={(e) => this.setState({ discountItems: e })}
              isMulti
              className="basic-multi-select"
              classNamePrefix="select"
            ></Select>
          </div>

          <div className="add_form_control">
            <label htmlFor="pPrice">Discount (%)</label>
            <input
              type="number"
              id="pPrice"
              onChange={(e) => this.setState({ discount: e.target.value })}
              value={this.state.discount}
            />
          </div>

          <button onClick={this.submit}>Save</button>
        </div>
      </div>
    );
  }
}
